export const DEFAULT_DATETIME = 'MMM dd, yyyy hh:mm a zzz';

export const DATETIME_NUMERIC_MONTH = 'MM/dd/yyyy h:mm:ss aa zzz';
export const DATETIME_NUMERIC_MONTH_NO_YEAR = 'M/dd h:mm:ss aa zzz';
export const TIME_NUMERIC_MONTH = 'h:mm:ss aa zzz';
